import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useDocumentTitle } from '@mantine/hooks';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { Container, Card, Group, Text, Select, Button, Grid, Radio, Box, Popover, TextInput, ScrollArea, Checkbox, useMantineTheme } from '@mantine/core';
import { IconHelp, IconX } from '@tabler/icons-react';
import './ReviewingTest.css';
import { CHART } from '../../utils/statusTokens';
import ReactDOM from 'react-dom';
import { Chart } from "react-google-charts";
import { visiUserData } from '../../GeneralFunction';
import { useNavigate,useLocation } from "react-router-dom";
import { notifications } from '@mantine/notifications';
import { VisiLoader, SelectTooltip } from "../../components/GeneralComponent/GeneralComponent";
import { OptimizeReport } from "../../components/TestHistoryReport/OptimizeReport";
import { ImpactSummary } from "../../components/ReviewingTest/ImpactSummary";
import { TestVariableData } from "../../components/TestHistoryReport/TestVariableData";
import { TestInfoModal } from "../../components/TestHistoryReport/TestInfoModal";
import { TestHistoryNotes } from '../../components/TestHistoryReport/TestHistoryNotes';
import { TestTotal } from "../../components/TestHistoryReport/TestTotal";
import TestsApi from "../../api/TestsApi";
import { ALL_OPTION_VALUE, isAllOptionValue, GOAL_TYPE_TO_RADIO, baseGoalType, allGoalType, buildGoalSelectData,
         buildGroupedGoalData, composeGoalValue, parseGoalValue } from '../../utils/goalAll';

export function TestHistoryReport() {
	const navigate = useNavigate();
  const location = useLocation();
  // previewStats: opened from Review Tests' "Preview Stats" on a page whose winner is
  // still set. Adds the variation preview links and waits for the snapshot if it isn't saved yet.
  const { pageId, historyId, previewStats } = location.state || {};
	useEffect(() => {
	  if(!visiUserData()){
	    navigate("/login");
	  }
	}, [navigate]);

	useDocumentTitle("Visiopt - Test History Report");

	const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');

	const handleHeaderMenuComponentChange = (Value:any) => {
	  setSelectedMemberWebsite(Value);
	};

  const theme = useMantineTheme();
  const isDark = theme.colorScheme === 'dark';

	const [convRedioBtn, setConvRedioBtn] = useState('1');

  const [variationsBtn, setVariationsBtn] = useState('1');
  const [variablesBtn, setVariablesBtn] = useState('0');
  const [variablesOptimumResponse, setVariablesOptimumResponse] = useState('');
  const [variablesVariablesTab, setVariablesVariablesTab] = useState([]);
  const [SystemUsageLoader, setSystemUsageLoader] = useState(false);

  const [convRadioFunnelsGoals, setConvRadioFunnelsGoals] = useState<any[]>([]);
  const [convRadioPostbackOptions, setConvRadioPostbackOptions] = useState<any[]>([]);
  const [convRadioButtonOptions, setConvRadioButtonOptions] = useState<any[]>([]);
  const [convRadioWebhookOptions, setConvRadioWebhookOptions] = useState<any[]>([]);
  const [allGoalsAvailable, setAllGoalsAvailable] = useState<Record<string, boolean | undefined>>({});
  const [allOptionValue, setAllOptionValue] = useState<string>(ALL_OPTION_VALUE);
  const [allGoalsMode, setAllGoalsMode] = useState(0);
  const [goalBreakdown, setGoalBreakdown] = useState<Record<string, any[]>>({});
  const [expandedVariations, setExpandedVariations] = useState<number[]>([]);
  const [funnelsGoals, setFunnelsGoals] = useState('');
  const [selectedButton, setSelectedButton] = useState('');
  const [postbackOptions, setPostbackOptions] = useState('');
  const [webhookOption, setWebhookOptions] = useState('');

  // Phase 5 — concluded-test Pause Recommended display. Backend returns the final
  // flagged variation IDs from the last day_key Phase 5 ran on this test, so the
  // P Status column can show 🟠 on rows that were flagged at conclusion (spec 7.2).
  const [pauseFlaggedIds, setPauseFlaggedIds] = useState<number[]>([]);
  // Phase 6 — Stage 5b forced resolution winner. Populated only when the test
  // was concluded via Stage 5b safety net (Section 7.3). Used to badge the
  // Test History page so the audit trail distinguishes forced resolution from
  // standard PREDICTED_WINNER or client-choice conclusion.
  const [phase6ForcedWinner, setPhase6ForcedWinner] = useState<number | null>(null);
  const [historyMasterId, setHistoryMasterId] = useState('');
  // Impact Summary numbers locked at Set Winner — shown as saved, never recalculated.
  const [impactSummary, setImpactSummary] = useState<any>(null);
  const [impactLockedDate, setImpactLockedDate] = useState('');
  const [testNameShow, setTestNameShow] = useState('');
  const [testPageLinkShow, setTestPageLinkShow] = useState('');
  const [testPageTitleShow, setTestPageTitleShow] = useState('');
  const [totalUniquesShow, setTotalUniquesShow] = useState('');
  const [totalVisitsShow, setTotalVisitsShow] = useState('');
  const [totalConversionsShow, setTotalConversionsShow] = useState('');
  const [testVariationsData, setTestVariationsData] = useState([]);
  const [dataColumnChart, setDataColumnChart] = useState([]);
  const [dataColumnPercentageChart, setDataColumnPercentageChart] = useState([]);
  const [selectedValue, setSelectedValue] = useState('1');
  const [variablesTabShow, setVariablesTabShow] = useState('');
  const [conversionTypeShow, setConversionTypeShow] = useState('');
  const [conversionTypeValueSelected, setConversionTypeValueSelected] = useState('');
  const [convtopageNameShow, setConvtopageNameShow] = useState('');
  const [isTestsNotesModalOpen, setIsTestsNotesModalOpen] = useState(false);
  const [noteTitle, setNoteTitle] = useState('');
  const [noteContent, setNoteContent] = useState('');
  const [testsName, setTestsName] = useState('');
  const [historyPendingMessage, setHistoryPendingMessage] = useState('');

  const variationRef = useRef(null);
  const variableRef = useRef(null);
  const testNameRef = useRef(null);
  const conversionToRef = useRef(null);
  const conversionToPageRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({});

/* VARIATIONS & VARIABLES*/
  const handleOptimize = (value:any) => {
    if(value === 'Variations'){
      setVariationsBtn('1');
      setVariablesBtn('0');
    } else if(value === 'Variables'){
      setVariationsBtn('0');
      setVariablesBtn('1');
      handleGetVariables();
    }
  };

  const handleGetVariables = () => {
    setSystemUsageLoader(true);
    TestsApi.gettesthistoryvariabletab({
      history_master_id: historyMasterId
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate('/logout');
        }
      }
    })
    .then((data) => {
      if (data.status === 1) {
        setVariablesOptimumResponse(data.data.optimum_response);
        setVariablesVariablesTab(data.data.variables_tab || []);
        setSystemUsageLoader(false);
      }
    })
    .catch((error) => {
      console.error('API Error:', error);
      setSystemUsageLoader(false);
    });
  };

/* END VARIATIONS & VARIABLES*/

/* CONVERSIONS TO*/
  const applyAllGoalsResponse = (payload: any) => {
    const isAll = Number(payload?.all_goals_mode) === 1 && payload?.goal_breakdown && typeof payload.goal_breakdown === 'object';
    setAllGoalsMode(isAll ? 1 : 0);
    setGoalBreakdown(isAll ? payload.goal_breakdown : {});
    setExpandedVariations(isAll
      ? Object.keys(payload.goal_breakdown).map((v) => Number(v)).filter((v) => !isNaN(v))
      : []);
  };

  const toggleVariationExpanded = (variationNumber: any) => {
    const variationNo = Number(variationNumber);
    setExpandedVariations((prev) =>
      prev.includes(variationNo) ? prev.filter((v) => v !== variationNo) : [...prev, variationNo]
    );
  };

  useEffect(() => {
    if(selectedMemberWebsite !== ''){
      if (!pageId) {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: "Page id is a required field.",
        });
        navigate('/review-tests');
        return;
      }
      if(pageId !== '' && historyId !== ''){
        if(previewStats){
          // Preview Stats can open before the cron has saved the snapshot - check on
          // every load so a refresh a few minutes later shows the data.
          TestsApi.checktesthistorydata({
            tests_history_id: historyId
          })
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              if (response.status === 401 || response.status === 400) {
                navigate("/logout");
              }
            }
          })
          .then(data => {
            if (data.status === 1) {
              loadConversionsDropdown();
            } else {
              setHistoryPendingMessage(data.message);
            }
          })
          .catch(error => {
            console.error("API Error:", error);
          });
        } else {
          loadConversionsDropdown();
        }
      }
    }
  }, [selectedMemberWebsite, pageId, navigate, historyId]);

  const loadConversionsDropdown = () => {
    TestsApi.gettesthistoryconversionsdropdown({
      history_id:historyId
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        setConvRadioFunnelsGoals(data.data.goal_options || []);
        setConvRadioPostbackOptions(data.data.postback_options || []);
        setConvRadioButtonOptions(data.data.button_options || []);
        setConvRadioWebhookOptions(data.data.webhook_options || []);
        setAllGoalsAvailable(data.data.all_goals_available || {});
        setAllOptionValue(data.data.all_option_value || ALL_OPTION_VALUE);
        setConversionTypeShow(data.data.conversion_type);
        setConversionTypeValueSelected(data.data.conversion_type_value_selected);
      } else {
        console.log("Error:","Error");
      }
    })
    .catch(error => {
      console.error("API Error:", error);
    });
  };

  const funnelGoal = useMemo(
    () => buildGoalSelectData(convRadioFunnelsGoals, 'goal_id', 'goal_name', 'goal', allGoalsAvailable.goal),
    [convRadioFunnelsGoals, allGoalsAvailable]);

  const postbackOption = useMemo(
    () => buildGoalSelectData(convRadioPostbackOptions, 'postback_id', 'postback_name', 'postback', allGoalsAvailable.postback),
    [convRadioPostbackOptions, allGoalsAvailable]);

  const buttonOptions = useMemo(
    () => buildGoalSelectData(convRadioButtonOptions, 'button_id', 'button_name', 'button', allGoalsAvailable.button),
    [convRadioButtonOptions, allGoalsAvailable]);

  const webhookOptions = useMemo(
    () => buildGoalSelectData(convRadioWebhookOptions, 'webhook_id', 'webhook_name', 'webhook', allGoalsAvailable.webhook),
    [convRadioWebhookOptions, allGoalsAvailable]);

  useEffect(() => {
    const selectedBaseType = baseGoalType(conversionTypeShow);
    if(selectedBaseType === 'goal'){
      setConvRedioBtn('1');
      const selectedOption = funnelGoal.find(option => option.value === conversionTypeValueSelected);
      if (selectedOption) {
        setFunnelsGoals(selectedOption.value);
      }
    }
    if(selectedBaseType === 'button'){
      setConvRedioBtn('2');
      const selectedOption = buttonOptions.find(option => option.value === conversionTypeValueSelected);
      if (selectedOption) {
        setSelectedButton(selectedOption.value);
      }
    }
    if(selectedBaseType === 'postback'){
      setConvRedioBtn('3');
      const selectedOption = postbackOption.find(option => option.value === conversionTypeValueSelected);
      if (selectedOption) {
        setPostbackOptions(selectedOption.value);
      }
    }
    if(selectedBaseType === 'webhook'){
      setConvRedioBtn('4');
      const selectedOption = webhookOptions.find(option => option.value === conversionTypeValueSelected);
      if (selectedOption) {
        setWebhookOptions(selectedOption.value);
      }
    }
  }, [conversionTypeValueSelected]);

  const groupedGoalData = useMemo(
    () => buildGroupedGoalData(
      { goal: convRadioFunnelsGoals, webhook: convRadioWebhookOptions,
        postback: convRadioPostbackOptions, button: convRadioButtonOptions },
      allGoalsAvailable,
      allOptionValue
    ),
    [convRadioFunnelsGoals, convRadioWebhookOptions, convRadioPostbackOptions, convRadioButtonOptions, allGoalsAvailable, allOptionValue]
  );

  const selectedGoalValue = useMemo(() => {
    const base = baseGoalType(conversionTypeShow);
    if (!base || !conversionTypeValueSelected) return null;
    const composite = composeGoalValue(base, conversionTypeValueSelected);
    return groupedGoalData.some((o) => o.value === composite) ? composite : null;
  }, [conversionTypeShow, conversionTypeValueSelected, groupedGoalData]);

  const handleSelectConvChange = (composite) => {
    const parsed = parseGoalValue(composite);
    if (!parsed) return;
    const selectedBaseType = parsed.type;
    const value = parsed.value;
    setConvRedioBtn(GOAL_TYPE_TO_RADIO[selectedBaseType] || '1');
    setConversionTypeShow(isAllOptionValue(value, allOptionValue) ? allGoalType(selectedBaseType) : selectedBaseType);
    setConversionTypeValueSelected(value);
    setFunnelsGoals('');
    setSelectedButton('');
    setPostbackOptions('');
    setWebhookOptions('');
    if (selectedBaseType === 'goal') {
      setFunnelsGoals(value);
    } else if (selectedBaseType === 'button') {
      setSelectedButton(value);
    } else if (selectedBaseType === 'postback') {
      setPostbackOptions(value);
    } else {
      setWebhookOptions(value);
    }
    setAllGoalsMode(0);
    setGoalBreakdown({});
    setExpandedVariations([]);
    if(value !== ''){
      setSystemUsageLoader(true);
    }
  };
/* END CONVERSIONS TO*/

/* TEST OPTIMIZE REPORT*/
  const fetchData = () => {
    TestsApi.testhistoryoptimizereport({
      system_website_id:selectedMemberWebsite,
      test_history_id:historyId,
      test_goal_type_opt_his: conversionTypeShow,
      convtogoal:convRedioBtn === '1' ? funnelsGoals : '',
      convtobutton:convRedioBtn === '2' ? selectedButton : '',
      convtopostback:convRedioBtn === '3' ? postbackOptions : '',
      convtowebhook:convRedioBtn === '4' ? webhookOption : '',
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
          setSystemUsageLoader(false);
        setTestVariationsData(data.data.test_history_data);
        applyAllGoalsResponse(data.data);
        setDataColumnChart(data.data.conversion_chart_column);
        setDataColumnPercentageChart(data.data.conversion_percentage_chart_column);
        setHistoryMasterId(data.data.history_master_id);
        setImpactSummary(data.data.impact_summary || null);
        setImpactLockedDate(data.data.impact_locked_date || '');
        setTestNameShow(data.data.test_name);
        setTestPageLinkShow(data.data.test_page_link);
        setTestPageTitleShow(data.data.page_title);
        setTotalUniquesShow(data.data.total_uniques);
        setTotalVisitsShow(data.data.total_visits);
        setTotalConversionsShow(data.data.total_conversions);
        setConvtopageNameShow(data.data.convtopage_name);
        setVariablesTabShow(data.data.hide_variables_tab);
        setNoteTitle(data.data.tests_note_title);
        setNoteContent(data.data.tests_note);
        setTestsName(data.data.tests_name);
        // Phase 5 — pause-flagged variation IDs ship in this same response, so the
        // P Status column paints 🟠 on first render (no follow-up API call).
        setPauseFlaggedIds(Array.isArray(data.data.pause_flagged_variation_ids)
          ? data.data.pause_flagged_variation_ids.map((v:any) => Number(v))
          : []);
        setPhase6ForcedWinner(data.data.phase6_forced_resolution_variation_id
          ? Number(data.data.phase6_forced_resolution_variation_id) : null);
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        setSystemUsageLoader(false);
      }
    })
    .catch(error => {
      console.error("API Error:", error);
      setSystemUsageLoader(false);
    });
  };

  useEffect(() => {
    if(selectedMemberWebsite !== '' && (funnelsGoals !== "" || postbackOptions !== "" || selectedButton !== "" || webhookOption !== "")){
      setSystemUsageLoader(true);
      fetchData();
    }
  }, [selectedMemberWebsite,funnelsGoals,postbackOptions,selectedButton,webhookOption]);

  const handleConversionRadioChange = (value) => {
    setSelectedValue(value);
  };

  // Same bar treatment as Review Tests: Control blue, the winner green, every
  // other variation neutral. Green means "good" across both pages, so painting
  // losing variations green would contradict it.
  //
  // Keying off the row index is safe: the API builds chart_data and
  // test_history_data in one while loop with $i and $j initialised together
  // ($i = $j = 0) and incremented on adjacent lines, so chart row N is always
  // table row N. Review Tests relies on the same guarantee.
  const chartBarColor = (i: number) => {
    if (i === 0) { return CHART.control; }
    const row: any = (testVariationsData as any[])[i];
    return row && row.is_winner ? CHART.variation : CHART.neutral;
  };

  const dataColumnChartRows = [
    ['Variation', 'Value', { role: 'style' }],
    ...(dataColumnChart as any[]).map((row: any, i: number) =>
      [row[0], row[1], chartBarColor(i)]),
  ];

  const optionsColumnChart = {
    legend: { position: 'none' },
    chartArea: { width: '90%', height: '80%' },
    backgroundColor: isDark ? '#1e1e1e' : '#fff',
    vAxis: {
      title: 'Conversions',
      titleTextStyle: { fontFamily: 'Cursive', fontSize: 16, color: isDark ? 'white' : 'black' },
      textStyle: { color: isDark ? 'white' : 'black' },
      gridlines: { color: isDark ? '#444' : '#ccc' },
      // Without this Google Charts picks its own baseline and exaggerates the
      // gaps - same fix as Review Tests.
      minValue: 0,
      viewWindow: { min: 0 },
    },
    hAxis: {
      textStyle: { color: isDark ? 'white' : 'black' },
      gridlines: { color: isDark ? '#444' : '#ccc' },
    },
  };

  const dataColumnPercentageChartRows = [
    ['Variation', 'Value', { role: 'style' }],
    ...(dataColumnPercentageChart as any[]).map((row: any, i: number) =>
      [row[0], row[1], chartBarColor(i)]),
  ];

  const optionsColumnPercentageChart = {
    legend: { position: 'none' },
    chartArea: { width: '90%', height: '80%' },
    backgroundColor: isDark ? '#1e1e1e' : '#fff',
    vAxis: {
      title: 'Conversions %',
      titleTextStyle: { fontFamily: 'Cursive', fontSize: 16, color: isDark ? 'white' : 'black' },
      textStyle: { color: isDark ? 'white' : 'black' },
      gridlines: { color: isDark ? '#444' : '#ccc' },
      // Without this Google Charts picks its own baseline and exaggerates the
      // gaps - same fix as Review Tests.
      minValue: 0,
      viewWindow: { min: 0 },
    },
    hAxis: {
      textStyle: { color: isDark ? 'white' : 'black' },
      gridlines: { color: isDark ? '#444' : '#ccc' },
    },
  };


  const allOptions = [
    { value: 'Uniques', label: 'Uniques' },
    { value: 'Visits', label: 'Visits' },
    { value: 'Conv. # to page', label: 'Conv. # to page' },
    { value: 'Conv. % to page', label: 'Conv. % to page' },
    { value: 'Percentage Improvement', label: 'Percentage Improvement' },
    { value: 'Statistical Significance', label: 'Statistical Significance' },
    { value: 'Subscription Revenue', label: 'Subscription Revenue' },
    { value: 'Avg. Time Spent', label: 'Avg. Time Spent' },
    { value: 'Total Revenue', label: 'Total Revenue' },
    { value: 'AOV', label: 'AOV' },
    { value: 'EPC', label: 'EPC' },
  ];

  const [opened, setOpened] = useState(false);
  const defaultSelectedOptions = [
    'Uniques',
    'Visits',
    'Conv. # to page',
    'Conv. % to page',
    'Percentage Improvement',
    'Statistical Significance'
  ];

  const [selectedfilteredOptions, setSelectedfilteredOptions] = useState<string[]>(defaultSelectedOptions);

  const handleToggle = (value: string) => {
    setSelectedfilteredOptions((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  useEffect(() => {
    const storedOptions = JSON.parse(localStorage.getItem('selectedTestHistoryColumns') || 'null');
    if (!storedOptions) {
      localStorage.setItem('selectedTestHistoryColumns', JSON.stringify(defaultSelectedOptions));
      setSelectedfilteredOptions(defaultSelectedOptions);
    } else {
      setSelectedfilteredOptions(storedOptions);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('selectedTestHistoryColumns', JSON.stringify(selectedfilteredOptions));
  }, [selectedfilteredOptions]);

/* END TEST OPTIMIZE REPORT*/ 


/* Tests NOTES */
  const handleTestsNotesOpenModal = (value:any) => {
    setIsTestsNotesModalOpen(true);
  };

  const handleTestsNotesCloseModal = () => {
    setIsTestsNotesModalOpen(false);
  };
/* END Tests NOTES */

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    const refMapping = {
      26: variationRef,
      27: variableRef,
      357: testNameRef,
      28: conversionToPageRef,
      287: conversionToRef
    };
    const iconRef = refMapping[id];
    if (iconRef.current) {
      const { top, left, width } = iconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        [id]: {top: top + scrollOffset, left: left + width + 10},
      });
    }
  };

	return (
	  <>
    <VisiLoader VisiLoaderVisible={SystemUsageLoader}/>
	  <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>
    {showHelpModal && Object.keys(tooltipPosition).map((key) => (
      ReactDOM.createPortal(
        <div>
          <SelectTooltip
            isVisible={showHelpModal}
            setIsVisible={setShowHelpModal}
            id={helpTargetId}
            tooltipPosition={tooltipPosition[key]} 
          />
        </div>,
      document.body
    )))}
	  <Container size="xxl">
      {/* Impact Summary - the numbers saved when the winner was set. Above the
          tabs, same as on Reviewing Test. Hidden for tests archived before the
          feature existed, since there is nothing saved to show. */}
      {impactSummary && (
        <ImpactSummary
          locked
          lockedData={impactSummary}
          lockedDate={impactLockedDate}
          goalName={impactSummary.goal_name || convtopageNameShow}
          goalKey={`locked:${conversionTypeShow}:${conversionTypeValueSelected}`}
        />
      )}
      <div style={{ display: 'flex',marginBottom:"10px"}}>
        <Box w={130}>
          <Button rightIcon={<IconHelp ref={variationRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(26)}/>} variant="default" bg={variationsBtn === '1' ? '#e7fcf5' : "" } type="submit" onClick={() => handleOptimize('Variations')} 
            sx={(theme) => {
              const isGreenBg = variationsBtn === '1';
              return {
                backgroundColor: isDark ? theme.colors.dark[5] : isGreenBg ? '#e7fcf5' : '#fff',
                color: isGreenBg ? 'black' : isDark ? 'white' : 'black',
                '&:hover': {
                  color: isDark ? 'white' : 'black',
                },
              };
            }}>
            Variations
          </Button>
        </Box>
        {variablesTabShow === 'show' &&(
          <Box w={130}>
            <Button rightIcon={<IconHelp ref={variableRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(27)}/>} variant="default" bg={variablesBtn === '1' ? '#e7fcf5' : "" } type="submit" onClick={() => handleOptimize('Variables')}>
              Test Variable Results
            </Button>
          </Box>
        )}
      </div>
      <div style={{ display: variationsBtn === '1' ? "block" : "none" }}>
  	  	<Card shadow="sm" padding="sm" radius="md" withBorder>
  	  		<div style={{ display: 'flex',marginBottom: '5px' }}>
  		  		<Group position="apart" mb="xs">
  		        <Text weight={500}>TEST HISTORY{(testsName || testPageTitleShow) ? ` - ${testsName || testPageTitleShow}` : ''} <IconHelp ref={testNameRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(357)}/></Text>
  		      </Group>
  		      <div style={{ display: 'flex',marginLeft:"auto"}}>
              {/*Notes Model*/}
              <Box>
                <Button variant="default" type="submit" onClick={() => handleTestsNotesOpenModal(1)}>
                  Tests Notes
                </Button>
              </Box>
              <TestHistoryNotes
                selectedMemberWebsite={selectedMemberWebsite}
                PageId={pageId}
                TestId={historyId}
                handleTestsNotesOpenModal={handleTestsNotesOpenModal}
                isTestsNotesModalOpen={isTestsNotesModalOpen}
                onTestsNotesClose={handleTestsNotesCloseModal}
                noteTitle={noteTitle}
                setNoteTitle={setNoteTitle}
                noteContent={noteContent}
                setNoteContent={setNoteContent}
              />
  		     		<TestInfoModal
                PageId={pageId}
                HistoryId={historyId}
              />
  		     	</div>
  		    </div>
  		    <Group>
  		      <Text mb={6}>Conversions to: <IconHelp ref={conversionToRef} size="1.1rem" color="red" style={{marginBottom:-4, cursor: 'pointer'}} onClick={() => handleHelpClick(287)}/></Text>
  		      {/* One searchable dropdown replaces the goal-type radios, same as the
  		          Test Review page, so both pages select goals identically. */}
  		      <Select
              value={selectedGoalValue}
              onChange={handleSelectConvChange}
              placeholder="Select a goal"
              searchable
              nothingFound="No goals found"
              maxDropdownHeight={320}
              data={groupedGoalData}
              withinPortal
              w={280}
            />
  		    </Group>
  		    <Group mt={10}>
            <div style={{ width: 280 }}>
              <Popover
                opened={opened}
                onChange={setOpened}
                position="bottom-start"
                width="target"
                trapFocus={false}
                withinPortal={true}
                transitionProps={{ transition: 'pop-top-left', duration: 150 }}
              >
                <Popover.Target>
                  <div onClick={() => setOpened((o) => !o)}>
                    <TextInput
                      readOnly
                      icon={
                        <span style={{
                          whiteSpace: 'nowrap',
                          color: isDark ? '#fff' : '#000',
                          fontSize: '0.8rem'
                        }}>
                          Select Metrics
                        </span>
                      }
                      rightSection={<span style={{ paddingRight: 10, color: isDark ? '#fff' : '#000' }}>▼</span>}
                      styles={{
                        input: {
                          cursor: 'pointer',
                          backgroundColor: isDark ? theme.colors.dark[6] : '#fff',
                          color: isDark ? '#fff' : '#000',
                          paddingLeft: 150,
                        },
                        icon: {
                          width: 120,
                          pointerEvents: 'none',
                        },
                      }}
                    />
                  </div>
                </Popover.Target>

                <Popover.Dropdown>
                  <ScrollArea style={{ height: 200 }}>
                    {allOptions.map((item) => (
                      <Checkbox
                        key={item.value}
                        label={item.label}
                        checked={selectedfilteredOptions.includes(item.value)}
                        onChange={() => handleToggle(item.value)}
                        styles={{ root: { cursor: 'pointer', padding: '4px 8px' } }}
                      />
                    ))}
                  </ScrollArea>
                  <Button fullWidth size="xs" mt="xs" onClick={() => setOpened(false)} variant="light">
                    Done
                  </Button>
                </Popover.Dropdown>
              </Popover>
            </div>
  		    </Group>
  		    {phase6ForcedWinner !== null && (
  		      <Box
  		        sx={(theme) => ({
  		          borderLeft: theme.colorScheme === 'dark' ? '4px solid #2f9e44' : '4px solid #40c057',
  		          backgroundColor: theme.colorScheme === 'dark' ? '#243f41' : '#ebfbee',
  		          padding: '8px 16px',
  		          marginTop: 12,
  		          marginBottom: 6,
  		          borderRadius: 4,
  		        })}
  		      >
  		        <Text size="sm" sx={(theme) => ({ color: theme.colorScheme === 'dark' ? '#ffffff' : 'green' })}>
  		          {'\u{1F7E2}'} Forced Resolution — Variation #{phase6ForcedWinner} declared winner.
  		          Two variations were statistically equivalent and no client decision was made within 30 days.
  		          Engine defaulted to current Trending Leader.
  		        </Text>
  		      </Box>
  		    )}
  		    <Group>
            <OptimizeReport
              SelectedFilteredOptions={selectedfilteredOptions}
              TestVariationsData={testVariationsData}
              PauseFlaggedIds={pauseFlaggedIds}
              AllGoalsMode={allGoalsMode}
              GoalBreakdown={goalBreakdown}
              ExpandedVariations={expandedVariations}
              OnToggleVariation={toggleVariationExpanded}
              ShowPreviewLinks={!!previewStats}
              EmptyMessage={historyPendingMessage}
            />
  		    </Group>
  			</Card>
  			{/* Nothing to chart until the snapshot is saved. */}
  			{historyPendingMessage === '' && (
  			<Card shadow="sm" padding="sm" radius="md" withBorder mt={10} mb={20}>
  				<Group position="apart" mb="xs">
  		      <Text weight={500}>CONVERSION TO PAGE/GOALS <IconHelp ref={conversionToPageRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(28)}/>   {convtopageNameShow}</Text>
  		    </Group>
  		    {/* The graph plots one goal at a time, so it is not shown while several
  		        goals are being all-goalsd side by side. */}
  		    {allGoalsMode !== 1 && (
  		    <Radio.Group
  		      name="Conversions"
  		      mb={10}
  		      value={selectedValue}
            onChange={handleConversionRadioChange}
  		    >
  		      <Group mt="md">
  		        <Radio value="1" label="Conversions" />
  		        <Radio value="2" label="Conversion %" />
  		      </Group>
  		    </Radio.Group>
  		    )}
  		    <Grid mb={15}>
  			    <Grid.Col span={9} style={{ textAlign: 'left' }}>
              {allGoalsMode === 1 ? (
                <Text size="sm" color="dimmed" mt={20}>
                  Each goal is reported separately in the table above — expand a variation to see its goals.
                  Select a single goal to see the graph.
                </Text>
              ) : dataColumnChartRows.length > 1 && dataColumnPercentageChartRows.length > 1 && (
    				   	<Chart
    					   	chartType="ColumnChart"
    					   	width="100%"
    					   	height="200px"
    					   	data={selectedValue === "1" ? dataColumnChartRows : dataColumnPercentageChartRows}
                  options={selectedValue === "1" ? optionsColumnChart : optionsColumnPercentageChart}

    					  />
              )}
  			    </Grid.Col>
  			    <Grid.Col span={3} style={{ textAlign: 'left' }} mt={20}>
  				    <TestTotal
                TestNameShow={testNameShow}
                TestPageLinkShow={testPageLinkShow}
                TestPageTitleShow={testPageTitleShow}
                TotalUniquesShow={totalUniquesShow}
                TotalVisitsShow={totalVisitsShow}
                TotalConversionsShow={allGoalsMode === 1 ? '—' : totalConversionsShow}
              />
  			    </Grid.Col>
  			  </Grid>
  			</Card>
  			)}
      </div>
      <div style={{ display: variablesBtn === '1' ? "block" : "none" }}>
        <TestVariableData
          VariablesData={variablesVariablesTab}
          VariableOptimumResponse={variablesOptimumResponse}
        />
      </div>
	  </Container>
	  </>
	);
}